import React from 'react';
import {Route, Switch} from 'react-router-dom';

import './index.css';

import StatisticsDashboard from './Dashboard';
import StatisticsUsers from './Users';
import StatisticsLeagues from './Leagues';
import StatisticsTournaments from './Tournaments';
import StatisticsBusiness from './Business';
import StatisticsPlayers from './Players';
import StatisticsMatches from './Matches';
import StatisticsVarious from './Various';
import StatisticsMessaging from './Messaging';
import StatisticsMasterLeague from './MasterLeague';

const Statistics = () => (
  <div id="statistics">
    <Switch>
      <Route exact path="/statistics" component={StatisticsDashboard} />
      <Route path="/statistics/users" component={StatisticsUsers} />
      <Route path="/statistics/leagues" component={StatisticsLeagues} />
      <Route path="/statistics/tournament" component={StatisticsTournaments} />
      <Route path="/statistics/business" component={StatisticsBusiness} />
      <Route path="/statistics/players" component={StatisticsPlayers} />
      <Route path="/statistics/matches" component={StatisticsMatches} />
      <Route path="/statistics/various" component={StatisticsVarious} />
      <Route path="/statistics/messaging" component={StatisticsMessaging} />
      <Route
        path="/statistics/masterLeague"
        component={StatisticsMasterLeague}
      />
    </Switch>
  </div>
);

export default Statistics;



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/index.js